module.exports = __webpack_public_path__ + "static/media/13.2ecd6439.jpg";